import { render } from "./BlogDetailsPageThree.vue?vue&type=template&id=4b50b5c6"
import script from "./BlogDetailsPageThree.vue?vue&type=script&lang=js"
export * from "./BlogDetailsPageThree.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__